import React, {memo} from "react";
import Skeleton, {SkeletonProps} from 'react-loading-skeleton';
import styled from "styled-components/macro";
import {device} from "../../styles";


const Root = styled.section`
    border: 1px solid var(--color-border-dropdown);

    ${device.less768} {
        display: none;
    }
`;

const Head = styled.div`
    width: 100%;
    min-height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
    user-select: none;

    ${device.less1180} {
        min-height: 42px;
        padding: 0 20px;
    }
`;

const Tags = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 5px 20px;
    padding: 5px 30px 20px 30px;

    ${device.less1180} {
        padding: 5px 20px 15px 20px;
    }
`;

const Body = styled.div`
    display: flex;
    gap: 20px;
    padding: 5px 30px 20px 30px;

    ${device.less1180} {
        gap: 15px;
        padding: 5px 20px 15px 20px;
    }
`;

const Item = styled.div`
    width: 45px;
    height: 45px;

    ${device.less1180} {
        width: 37px;
        height: 37px;
    }
`;

export const ComplectationsSectionSkeleton = memo((props: SkeletonProps & { hasTags?: boolean }) => {
    const {hasTags, ...rest} = props;

    return (
        <Root {...rest}>
            <Head>
                <Skeleton height={22} width={'50%'}/>

                <div style={{marginLeft: 'auto'}}>
                    <Skeleton height={22} width={22}/>
                </div>
            </Head>

            {
                hasTags &&
                <Tags>
                    <div style={{width: '30%'}}><Skeleton height={22}/></div>
                    <div style={{width: '20%'}}><Skeleton height={22}/></div>
                    <div style={{width: '10%'}}><Skeleton height={22}/></div>
                    <div style={{width: '10%'}}/>

                    <div style={{width: '20%'}}><Skeleton height={22}/></div>
                    <div style={{width: '15%'}}><Skeleton height={22}/></div>
                    <div style={{width: '5%'}}><Skeleton height={22}/></div>
                </Tags>
            }

            <Body>
                <Item><Skeleton circle width={'100%'} height={0} style={{paddingTop: '100%'}}/></Item>
                <Item><Skeleton circle width={'100%'} height={0} style={{paddingTop: '100%'}}/></Item>
                <Item><Skeleton circle width={'100%'} height={0} style={{paddingTop: '100%'}}/></Item>
                <Item><Skeleton circle width={'100%'} height={0} style={{paddingTop: '100%'}}/></Item>
                <Item><Skeleton circle width={'100%'} height={0} style={{paddingTop: '100%'}}/></Item>
            </Body>
        </Root>
    )
});

